<template>
    <v-layout class="ck-editor">
        <textarea :id="editorId" :value="value" :data-qe-id="editorId"></textarea>
    </v-layout>
</template>

<script>
import { ckEditorType } from '../../plugins/CkEditor/ckEditorTypes.config';
import { mapActions } from 'vuex';
import { storeAction } from '../../store/storeActions.constant';

import CKEditorMixin from '../../mixins/CKEditorMixin';

export default {
    name: 'MemberMentionTextArea',
    mixins: [CKEditorMixin],
    props: {
        atchars: {
            type: Number,
            default: 3,
        },
        value: {
            type: String,
        },
        editorId: {
            type: String,
            required: true,
            default: 'memberMentionEditor',
        },
        editorType: {
            type: String,
            default: ckEditorType.SIMPLE_WITH_MENTIONS,
        },
        height: {
            type: String,
            default: '100%',
        },
        width: {
            type: String,
            default: '100%',
        },
        language: {
            type: String,
            default: 'en',
        },
        extraPlugins: {
            type: String,
            default: '',
        },
        autoFocus: {
            type: Boolean,
            default: true,
        },
    },

    data: () => ({
        memberMentionsCallback: null,
        timeoutForTypeAhead: null,
    }),

    methods: {
        ...mapActions({
            getMemberMentions: `chapter/${storeAction.getMentionsList}`,
        }),

        dataFeed(opts, callback) {
            if (opts && opts.query.length >= 3) {
                clearTimeout(this.timeoutForTypeAhead);
                this.timeoutForTypeAhead = setTimeout(() => {
                     this.getMemberMentions(opts.query).then((response) => {
                        response.data.forEach((res, index) => {
                            res.userId = res.id;
                            res.id = index + 1;
                        });
                        this.memberMentionsCallback = callback;
                        callback(response.data);
                    });
                }, 1500);
            }
        },
    },
    /* eslint-enable no-undef */
};
</script>

<style lang="scss">
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_responsive.scss';

.ck-editor {
    position: relative;

    .cke {
        border: none;
        position: relative;
    }

    .cke_top {
        border: none;
        background-color: $ypo-title-blue-gray;
    }

    .cke_bottom {
        background-color: $white;
        display: none;
        border-top: none;
        border-bottom: 2px solid $ypo-medium-gray;
    }

    .cke_editable {
        display: inline;
    }

    a {
        &.cke_button {
            height: 100%;
            cursor: pointer;
        }
    }

    .cke_path {
        display: none;
    }
}

.cke_autocomplete_panel {
    border-radius: 4px;
    width: 330px !important;
    max-height: 380px !important;
    box-shadow: 0 8px 10px 1px rgba($black, 0.14), 0 3px 14px 2px rgba($black, 0.12), 0 5px 5px -3px rgba($black, 0.2);

    border: none !important;

    li {
        position: relative;
        min-height: 75px;
        display: flex;
        align-items: center;
    }

    figure {
        width: 50px;
        border: none;
        margin: 0;
        padding: 0;
        height: 50px;
        overflow: hidden;
        position: absolute;
        border-radius: 50px;
        outline: none;
    }

    img {
        max-width: 100%;
    }

    span {
        padding-left: 60px;
        display: block;
        color: $ypo-cta;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0.25px;
        line-height: 18px;
        font-family: Noto Sans, sans-serif;
    }

    small {
        margin-top: 5px;
        display: block;
        color: $ypo-cta;
        font-size: 12px;
        letter-spacing: -0.1px;
        line-height: normal;
        font-weight: 400;
    }

    strong {
        text-decoration: none;
    }
}
@include breakpoint(xs) {
        .cke_autocomplete_opened {
        left: 0 !important;
        right: 0 !important;
        margin: 0 auto !important;
        }
}
</style>
